module.exports = __webpack_public_path__ + "static/product-page-right.4e25d37e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product-page-right.jpg
// module id = 1507
// module chunks = 168707334958949